package com.example.mystybag.communication.internal

import kotlinx.datetime.Clock

internal actual fun getRequestTimestampMs(): Long =
    Clock.System.now().toEpochMilliseconds()
